import React from 'react';

const CareNetworkIcon = ({ isActive }) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='care-network-icon'>
      <path
        d='M9.33268 1.75008C9.33268 1.59537 9.27122 1.447 9.16183 1.3376C9.05243 1.22821 8.90406 1.16675 8.74935 1.16675H5.24935C5.09464 1.16675 4.94627 1.22821 4.83687 1.3376C4.72747 1.447 4.66602 1.59537 4.66602 1.75008V4.66675H1.74935C1.59464 4.66675 1.44627 4.72821 1.33687 4.8376C1.22747 4.947 1.16602 5.09537 1.16602 5.25008V8.75008C1.16602 8.90479 1.22747 9.05316 1.33687 9.16256C1.44627 9.27196 1.59464 9.33342 1.74935 9.33342H4.66602V12.2501C4.66602 12.4048 4.72747 12.5532 4.83687 12.6626C4.94627 12.772 5.09464 12.8334 5.24935 12.8334H8.74935C8.90406 12.8334 9.05243 12.772 9.16183 12.6626C9.27122 12.5532 9.33268 12.4048 9.33268 12.2501V9.33342H12.2493C12.4041 9.33342 12.5524 9.27196 12.6618 9.16256C12.7712 9.05316 12.8327 8.90479 12.8327 8.75008V5.25008C12.8327 5.09537 12.7712 4.947 12.6618 4.8376C12.5524 4.72821 12.4041 4.66675 12.2493 4.66675H9.33268V1.75008Z'
        stroke='#9D9D9D'
        strokeWidth='1.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#00778B' : '#9D9D9D'}
      />
    </svg>
  );
};

export default CareNetworkIcon;
